module.exports = __webpack_public_path__ + "static/dam.73dec70b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dam.jpg
// module id = 435
// module chunks = 35783957827783